import { BimDataConfigInterface } from '@core/interfaces/bimdata-config.interface';

export class BimDataConfig {
  /**
   * The bimData api base url
   */
  bimDataUrl: string;

  /**
   * The bimData api scope
   */
  scope: string;

  /**
   * Creates an instance of BydbimDataConfig.
   *
   * @param settings the bimData api settings
   */
  constructor(settings: BimDataConfigInterface) {
    this.bimDataUrl = settings?.bimDataUrl;
    this.scope = settings?.scope;
  }
}
